import React from "react";
import SEO from "../components/SEO";
import HeroInner from "../components/HeroInner/HeroInner";
import Services from "../components/Services";
import ChatBot from "../components/ChatBot";
import GlobalScripts from "../components/GlobalScripts";
import Menu from "../components/Menu/Menu";
import "./DesarrolloWeb.css";

function Marketing() {
  return (
    <>
      <SEO
        title="Marketing Digital | SEO, Ads y Estrategias"
        description="Estrategias de marketing digital para generar tráfico y ventas."
        url="https://juancarlosmancharamos.ar/marketing-digital"
      />

      <Menu />

      <HeroInner
        title="Marketing Digital"
        subtitle="SEO, Ads y estrategias para crecer online"
        bg="/assets/images/bg-dev.jpg"
      />

      <section className="container dev-section">
        <h2>Generá tráfico y clientes</h2>

        <p>
          Estrategias de marketing digital enfocadas en resultados: SEO,
          publicidad online y optimización de conversiones.
        </p>

        <p>
          Trabajo con Google Ads, Facebook Ads y posicionamiento orgánico.
        </p>

        <h3>Resultados reales</h3>

        <p>
          Más visitas, más leads y mayor retorno de inversión.
        </p>
      </section>

      <section id="abt-lnk" className="center-first">
        <div className="container text-center">
          <h2>+ servicios</h2>
          <Services />
        </div>
      </section>

      <ChatBot />
      <GlobalScripts />
    </>
  );
}

export default Marketing;